'use strict';

angular.module('Login').controller('ResetController', function ($scope, $location, $route, AuthenticationService) {
	$scope.params = $route.current.params || {};
	var token = $scope.params.token || false;
	$scope.dataLoading = false;
    	AuthenticationService.checkToken({token: token},
		function(response) {
            if(response && response.status == 200){
            	$scope.showForm = true;
            	$scope.showSuccessView = false;
            	$scope.showErrorView = false;
            }else{
            	$scope.showForm = false;
            	$scope.showSuccessView = false;
            	$scope.showErrorView = true;
            }
        }, function() {
           	$scope.showForm = false;
        	$scope.showSuccessView = false;
        	$scope.showErrorView = true;
        });

    $scope.changePassword = function (passwordForm) {
        passwordForm.token = token;
		$scope.dataLoading = true;
		AuthenticationService.changePassword(passwordForm,
			function(resonnse){
				// $scope.showForm = false;
				$scope.dataLoading = false;
				$location.path('/auth/changed');
				// $scope.showSuccessView = true;
			},function(error){
				$scope.dataLoading = false;
				$scope.error = error.data.message;
			});
    }

    $scope.retrunLogin =function(){
    	$location.path('/auth');
    }

});



//////////////////
// WEBPACK FOOTER
// ./auth/js/controllers/ResetController.js
// module id = 146
// module chunks = 0